import React, { useState } from 'react';
import { analystAPI } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';

/**
 * LinkSleeperBlock — the missing step for accounts created by magic link
 * alone (email only, no Sleeper). Links a Sleeper username to the signed-in
 * account, then refreshes auth so ShellContext loads leagues everywhere.
 */

const LinkSleeperBlock = ({ note }) => {
  const { refreshUser } = useAuth();
  const [name, setName] = useState('');
  const [linking, setLinking] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    const clean = name.trim().replace(/^@/, '');
    if (!clean || linking) return;
    setLinking(true);
    setError(null);
    try {
      await analystAPI.linkSleeper(clean);
      await refreshUser();
    } catch (err) {
      setError(err?.response?.data?.error || 'Could not link that username — try again');
      setLinking(false);
    }
  };

  return (
    <div className="ft-card" style={{ maxWidth: 480 }}>
      <span className="ft-k">Link your Sleeper</span>
      <p className="ft-sub" style={{ fontSize: 13.5, margin: '8px 0 14px' }}>
        {note || 'Your leagues load from your Sleeper account — link it once and everything fills in.'}
      </p>
      <form onSubmit={submit} style={{ display: 'flex', gap: 10 }}>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Sleeper username"
          style={{
            flex: 1, background: '#FFFFFF', border: 'none', borderRadius: 'var(--ft-r-input, 12px)',
            padding: '13px 16px', fontSize: 15, outline: 'none',
          }}
        />
        <button type="submit" className="ft-btn sm" disabled={linking}>
          {linking ? 'Linking…' : 'Link'}
        </button>
      </form>
      {error ? <p style={{ color: '#FF3B30', fontSize: 12.5, margin: '10px 0 0' }}>{error}</p> : null}
    </div>
  );
};

export default LinkSleeperBlock;
